import { makeStyles, Theme, createStyles } from "@material-ui/core";
import colors from "../../../../styles/colors";
import palette from "../../../../styles/palette";
import { StyleMenuProps } from "../../styles/index.styles";

/**
 * Item da sidebar no padrão do mockup Lovable: linha de 20px/14px, ícone
 * esmeralda de 20px, rótulo em `sidebar-foreground`, hover/ativo em
 * `sidebar-accent`, submenus recuados com tipografia menor.
 */
export const useStyles = makeStyles<Theme, StyleMenuProps>((theme) =>
  createStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      padding: ({ visibleMenu }) => (visibleMenu ? 0 : "0px 10px"),
      "&:hover": {
        backgroundColor: ({ visibleMenu }) =>
          visibleMenu ? colors.purpleDarkMedium : "transparent",
      },
    },
    content: {
      display: "flex",
      alignItems: "center",
      padding: ({ visibleMenu }) => (visibleMenu ? "14px 20px" : "18px 0px"),
      justifyContent: ({ visibleMenu }) =>
        visibleMenu ? "flex-start" : "center",
      gap: "12px",
      textDecoration: "none",
      borderRadius: ({ visibleMenu }) => (visibleMenu ? 0 : 50),
      textAlign: "center",
      transition: "background-color .15s ease",
      "&:hover": {
        backgroundColor: colors.purpleDarkMedium,
      },
    },
    containerSubmenu: {
      display: "flex",
      flexDirection: "column",
      gap: 2,
      paddingBottom: 8,
    },
    Icon: {
      color: palette.emerald,
      fontSize: 20,
    },
    wrapper: {
      display: "flex",
      width: "100%",
      justifyContent: "space-between",
      alignItems: "center",
    },
    titleMenu: {
      color: colors.grayLightest,
      fontSize: "0.875rem",
      cursor: "pointer",
    },
    iconArrow: {
      fontSize: 16,
      color: colors.grayMedium,
      cursor: "pointer",
    },
    submenu: {
      cursor: "pointer",
      zIndex: 50,
      borderRadius: 6,
      padding: ({ visibleMenu }) =>
        visibleMenu ? "2px 12px 2px 52px" : "0.5px 10px",
      "&:hover": {
        backgroundColor: colors.purpleDarkMedium,
      },
    },
    containerTooltip: {
      position: "absolute",
      flex: "none",
      display: "flex",
      textAlign: "left",
      justifyContent: "flex-start",
      flexDirection: "column",
      zIndex: 30,
      width: "200%",
    },
    wrapperTooltip: {
      backgroundColor: colors.purpleDark,
      padding: "8px 12px",
      borderTopLeftRadius: 6,
      borderTopRightRadius: 6,
      color: colors.white,
      boxShadow: palette.shadowMd,
    },
    wrapperTooltipNoSub: {
      backgroundColor: colors.purpleDark,
      padding: "8px 12px",
      borderRadius: 6,
      color: colors.white,
      boxShadow: palette.shadowMd,
    },
    containerTooltipSubmenus: {
      backgroundColor: colors.bgSubmenuHover,
      borderBottomLeftRadius: 6,
      borderBottomRightRadius: 6,
      padding: "8px 0px",
      boxShadow: palette.shadowMd,
    },
  })
);
